import { useState } from "react";
import { Minus, Plus, Sparkles } from "lucide-react";
import { IngredientInputComponent } from "../IngredientInputComponent";

export function AddItemComponent({
  onAddItem,
  quantityUnits,
  addingToLabel,
  onOpenAiFillModal,
}) {
  const [ingredientToAdd, setIngredientToAdd] = useState({
    name: "",
    quantity: "",
    unit: quantityUnits[0],
  });
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleAddItem = () => {
    const addIngredientRequest = {
      itemName: ingredientToAdd.name,
      itemQuantity: ingredientToAdd.quantity,
      itemUnit: ingredientToAdd.unit,
    };
    onAddItem(addIngredientRequest);
    setIngredientToAdd({
      name: "",
      quantity: "",
      unit: quantityUnits[0],
    });
  };

  return (
    <div className="space-y-2">
      {/* Toggle Button */}
      <div className="flex items-center flex-wrap gap-3">
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors shrink-0 whitespace-nowrap"
        >
          {isCollapsed ? <Plus className="w-4 h-4" /> : <Minus className="w-4 h-4" />}
          Add item
        </button>
        {onOpenAiFillModal && (
          <button
            type="button"
            onClick={onOpenAiFillModal}
            className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors shrink-0 whitespace-nowrap"
          >
            <Sparkles className="w-4 h-4" />
            Fill with AI
          </button>
        )}
        {addingToLabel && (
          <span className="text-xs text-gray-400 whitespace-nowrap">
            Adding to: {addingToLabel}
          </span>
        )}
      </div>

      {/* Form Content */}
      <div
        className={`
          transition-all duration-300 ease-in-out
          ${isCollapsed ? "max-h-0 opacity-0 overflow-hidden" : "max-h-[500px] opacity-100 overflow-visible"}
        `}
      >
        <div className="space-y-2 md:space-y-0 md:flex md:flex-row md:gap-2">
          {/* Item Name */}
          <IngredientInputComponent
            ingredient={ingredientToAdd}
            quantityUnits={quantityUnits}
            onChange={(field, value) =>
              setIngredientToAdd((prev) => ({ ...prev, [field]: value }))
            }
            onEnterPress={(completedItem) => {
              onAddItem(completedItem);
              setIngredientToAdd({
                name: "",
                quantity: "",
                unit: quantityUnits[0],
              }); // Clear box
            }}
          />

          {/* Add Button */}
          <button
            onClick={handleAddItem}
            className="w-full md:w-auto px-4 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
          >
            <Plus className="w-4 h-4" />
            <span>Add</span>
          </button>
        </div>
      </div>
    </div>
  );
}
